export default __webpack_public_path__ + "static/media/51_desktop.42e0d1ef.jpg";